import { Button } from "@do/ui/components/button";
import { cn } from "@do/ui/lib/utils";
import { ArrowDownIcon } from "lucide-react";
import { motion } from "motion/react";
import { useTranslations } from "next-intl";
import { useMotionEnabled } from "../../hooks/use-motion-enabled";
import {
  BUTTON_REVEAL_TIMING,
  getRevealProps,
  SCROLL_TO_BOTTOM_OFFSET_Y,
  SCROLL_TO_BOTTOM_SCALE_FROM,
} from "../../lib/motion-presets";
import { useChat } from "../../providers/chat-provider";

export const FooterScrollToBottomButton = () => {
  const { scrollToBottom } = useChat();
  const t = useTranslations("do-chat-v2");
  const motionEnabled = useMotionEnabled();

  return (
    // The positioning lives out here rather than on the button, because an animated wrapper
    // carries a transform, and a transform makes it the containing block for anything
    // absolutely positioned inside it — the button's `bottom: …+100%` would then resolve
    // against a zero-height wrapper instead of the footer.
    <motion.div
      className={cn(
        "absolute z-10",
        "right-(--footer-scroll-to-bottom-button-right)",
        "left-(--footer-scroll-to-bottom-button-left)",
        "bottom-[calc(var(--footer-scroll-to-bottom-button-bottom)+100%)]"
      )}
      {...getRevealProps({
        motionEnabled,
        timing: BUTTON_REVEAL_TIMING,
        offsetY: SCROLL_TO_BOTTOM_OFFSET_Y,
        scaleFrom: SCROLL_TO_BOTTOM_SCALE_FROM,
        withExit: true,
      })}
    >
      <Button
        id="footer-scroll-to-bottom-button"
        aria-label={t("chat.footer.accessibility.scroll-to-bottom-aria-label")}
        className={cn(
          "size-(--footer-input-actions-button-size)",
          "rounded-(--footer-input-actions-button-border-radius)",
          "bg-(--footer-scroll-to-bottom-button-background)/(--footer-scroll-to-bottom-button-background-opacity)",
          "hover:bg-(--footer-scroll-to-bottom-button-hover-background)/(--footer-scroll-to-bottom-button-hover-background-opacity)",
          "border-(length:--footer-scroll-to-bottom-button-border-width)",
          "border-(--footer-scroll-to-bottom-button-border-color)/(--footer-scroll-to-bottom-button-border-opacity)",
          "hover:border-(--footer-scroll-to-bottom-button-hover-border-color)/(--footer-scroll-to-bottom-button-hover-border-opacity)",
          "[box-shadow:var(--footer-scroll-to-bottom-button-box-shadow)]"
        )}
        onClick={() => scrollToBottom({ force: true })}
        size="icon"
      >
        <ArrowDownIcon
          id="footer-scroll-to-bottom-button-icon"
          aria-hidden="true"
          className={cn(
            "size-(--footer-scroll-to-bottom-button-icon-size)",
            "text-(--footer-scroll-to-bottom-button-icon-color)/(--footer-scroll-to-bottom-button-icon-color-opacity)"
          )}
        />
      </Button>
    </motion.div>
  );
};
